import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Copy, ExternalLink } from "lucide-react";
import { BRAND, errMsg } from "./constants";

export function KitPanel({ property, authFetch, API }) {
  const [rules, setRules] = useState("");
  const [items, setItems] = useState("");
  useEffect(() => { setRules(property.house_rules || ""); setItems((property.kit_items || []).join("\n")); }, [property]);
  const publicUrl = `${window.location.origin}/homestay/p/${property.id}`;

  const save = async () => {
    try {
      await authFetch({ method: "patch", url: `${API}/homestay/properties/${property.id}/kit`, data: { house_rules: rules, kit_items: items.split("\n") } });
      toast.success("Onboarding kit saved");
    } catch (e) { toast.error(errMsg(e, "Could not save")); }
  };

  return (
    <div data-testid="kit-panel" className="rounded-2xl border-2 bg-white p-4" style={{ borderColor: BRAND.line }}>
      <div className="text-sm font-bold" style={{ color: BRAND.green }}>Guest onboarding kit</div>
      <div className="mt-2 rounded-xl p-2.5 text-xs flex items-center gap-2" style={{ background: "#F0FDF4" }}>
        <span className="truncate flex-1" data-testid="kit-public-url">{publicUrl}</span>
        <button data-testid="kit-copy-url" onClick={() => navigator.clipboard.writeText(publicUrl).then(() => toast.success("Link copied"))}><Copy className="w-3.5 h-3.5" /></button>
        <a href={publicUrl} target="_blank" rel="noreferrer" data-testid="kit-open-public"><ExternalLink className="w-3.5 h-3.5" /></a>
      </div>
      <label className="block mt-3 text-[10px] uppercase tracking-widest font-bold" style={{ color: BRAND.muted }}>House rules</label>
      <textarea data-testid="kit-rules-input" rows={4} className="mt-1 w-full rounded-xl border-2 px-3 py-2 text-sm" value={rules} onChange={(e) => setRules(e.target.value)} placeholder="Gate closes 11 PM · No smoking · Visitors till 8 PM" />
      <label className="block mt-2 text-[10px] uppercase tracking-widest font-bold" style={{ color: BRAND.muted }}>Welcome kit items (one per line)</label>
      <textarea data-testid="kit-items-input" rows={4} className="mt-1 w-full rounded-xl border-2 px-3 py-2 text-sm" value={items} onChange={(e) => setItems(e.target.value)} placeholder={"Bedsheet + pillow\nLocker key\nWiFi password card"} />
      <button data-testid="kit-save-btn" onClick={save} className="mt-2 rounded-full px-5 py-2 text-sm font-bold text-white" style={{ background: BRAND.green }}>Save kit</button>
    </div>
  );
}
